import classNames from 'classnames'
import React from 'react'

import { type IconName } from '~/utils'

import styles from './Icon.css'

export type IconProps = JSX.IntrinsicElements['span'] & {
  'data-testid'?: string
  icon: IconName
  size: '1.5em' | '1.25rem' | '1em' | '1rem' | '2em'
}

export const Icon = ({
  className,
  'data-testid': dataTestId = 'components-elements-icon',
  icon,
  size,
  ...rest
}: IconProps) => (
  <span
    className={classNames(
      'k-icon',
      'k-font-icon',
      `k-i-${icon}`,
      styles[`size-${size.replace('.', '_')}`],
      className,
    )}
    data-testid={dataTestId}
    {...rest}
  />
)
